/** @jsxImportSource @emotion/react */

import ExternalLink from '../ExternalLink';
import useStyles from './styles';

const CFADivider = ({ filterShowHide, isMapPage, isMobile }) => {
  const styles = useStyles();
  const contactLink = (
    <ExternalLink
      css={styles.CFADividerLink}
      href={
        'https://www.englandfootball.com/participate/leagues-and-clubs/county-football-associations/contact'
      }
    >
      your local County FA
    </ExternalLink>
  );

  return (
    <div css={styles.CFADividerCont(filterShowHide, isMapPage, isMobile)}>
      {isMobile ? (
        <div css={styles.mobileTextWrapper}>
          <p css={styles.textHeading}>Can't find what you're looking for? </p>
          <p css={styles.textDescription}>
            Get in touch with {contactLink} for support in finding suitable
            playing opportunities
          </p>
        </div>
      ) : (
        <>
          <div css={styles.CFADividerLeftFill(isMapPage)}></div>
          <p css={styles.CFADividerText}>
            Can't find what you're looking for? Contact {contactLink} for
            support in finding suitable playing opportunities
          </p>
          <div css={styles.CFADividerRightFill(isMapPage)}></div>
        </>
      )}
    </div>
  );
};

export default CFADivider;
